<template>
  <div :class="['definition-wrapper', 'chart', 'pie-chart', {'error_validate': mandatoryValidation}]">
    <GChart v-if="componentMounted"
      type="PieChart"
      :data="chartData"
      :options="chartOptions"
      :settings="chartSettings"
    />
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts'
import transport from 'vue-definition-utils/src/utils/transport'
import language from '../../language'

export default {
  name: 'definition-pie-chart',
  props: [
    'definition',
    'object',
    'definitionObject',
    'editable',
    'mandatoryValidation',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'requestObjectForAdd',
    'requestObjectForAddModified',
    'visualDefinition',
    'language',
    'callTask'
  ],
  components: {
    GChart
  },
  data () {
    return {
      componentMounted: false,
      chartData: [],
      chartOptions: {},
      chartSettings: {}
    }
  },
  methods: {
    getDefinitionHeight () {
      var definition = this.visualDefinition.getDefinitionFields(this.definition.id)
      return definition.height
    }
  },
  beforeMount () {
    var dataChart = transport.methods.getDataChart(JSON.parse(JSON.stringify(this.object.chartValue)))
    this.chartData = dataChart.chartData

    this.chartOptions.pieHole = 0.4
    var height = this.getDefinitionHeight()
    if (height) {
      this.chartOptions.height = height
    }
    this.chartOptions.fontSize = 16
    this.chartOptions.pieSliceTextStyle = {
      color: '#000',
      fontSize: 25
    }
    this.chartOptions.slices = {
      0: {color: '#5DD23C'},
      1: {color: '#efefef'}
    }

    this.chartSettings.packages = ['corechart']
    this.chartSettings.language = language(this.language, 'chart')

    this.componentMounted = true
  }
}
</script>

<style lang="scss">
  .pie-chart {
    min-height: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/chart/pieChart.vue